module.exports = __webpack_public_path__ + "static/eight-economic-growth.129a5174.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/eight-economic-growth.webp
// module id = 923
// module chunks = 3